import { useRouter } from 'next/router';
import CardList from '../TabB/CardList';
import GiftBox from './GiftBox';
import Lottery from './Lottery';

export default function TabA() {
    const { locale } = useRouter();

    return (
        <>
            {locale !== 'au' && <GiftBox />}
            {locale !== 'au' && <Lottery />}
            {['kr'].includes(locale as string) && <CardList />}
        </>
    );
}
